import React from 'react';
import { ArrowRight, ChefHat, Leaf } from 'lucide-react';

const CTA = ({ language }) => {
  const texts = {
    en: {
      title: 'Get Started with Souschaif Today!',
      subtitle: 'Take the first step toward a smarter, more sustainable kitchen. Turn everyday ingredients into incredible meals.',
      cta: 'Join Now',
      features: [
        'AI Recipes',
        'Less Food Waste',
        'Smart Shopping',
        'Personalized Meals'
      ]
    },
    sl: {
      title: 'Začnite s Souschaif še danes!',
      subtitle: 'Naredite prvi korak do pametnejše in bolj trajnostne kuhinje. Vsakodnevne sestavine spremenite v odlične obroke.',
      cta: 'Pridružite se',
      features: [
        'AI recepti',
        'Manj odpadne hrane',
        'Pametno nakupovanje',
        'Osebni obroki'
      ]
    }
  };

  const t = texts[language];

  return (
    <section id="section-5" className="py-20 bg-gradient-to-br from-emerald-600 to-green-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-white">
          <div className="mb-8">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 rounded-full mb-6">
              <ChefHat className="w-10 h-10 text-white" />
            </div>
            
            <h2 className="text-4xl lg:text-5xl font-bold mb-6">
              {t.title}
            </h2>
            
            <p className="text-xl text-emerald-50 max-w-3xl mx-auto mb-8">
              {t.subtitle}
            </p>
          </div>

          <div className="flex justify-center items-center mb-12">
            <a href="/s" className="bg-white text-emerald-700 px-8 py-4 rounded-xl font-semibold text-lg hover:bg-emerald-50 transition-colors duration-200 flex items-center space-x-2 shadow-lg">
              <Leaf className="w-6 h-6" />
              <span>{t.cta}</span>
              <ArrowRight className="w-5 h-5" />
            </a>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-emerald-50">
            {t.features.map((feature, index) => (
              <div key={index} className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-lime-300 rounded-full"></div>
                <span className="text-sm font-medium">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
